import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import GlobalContainer from '@ui/container/global-container';
import CastHeaderColumn from './cast-header-column';
import { ESortOrderMap, SortDirection } from '@ui/buttons/sort-button/types';

const CrewContentTableHeader = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleSortClick = useCallback(
    (type: string) => (_label: string, direction: SortDirection) => {
      setSearchParams((prev) => {
        const paramsCopy = new URLSearchParams(prev);
        paramsCopy.delete('sortBy');
        paramsCopy.delete('sortOrder');
        paramsCopy.set('page', '1');
        if (direction !== SortDirection.none) {
          paramsCopy.set('sortBy', type);
          const order = direction === SortDirection.down ? ESortOrderMap.desc : ESortOrderMap.asc;
          paramsCopy.set('sortOrder', order.toString());
        }
        return paramsCopy;
      });
    },
    [setSearchParams]
  );

  const getSortDirection = useCallback(
    (type: string): SortDirection => {
      const sortOrderParam = searchParams.get('sortOrder');
      const sortByParam = searchParams.get('sortBy');
      if (type !== sortByParam) {
        return SortDirection.none;
      }

      if (!sortOrderParam || isNaN(Number(sortOrderParam))) {
        return SortDirection.none;
      }

      const sortOrderParamNum = Number(sortOrderParam);

      if (sortOrderParamNum === ESortOrderMap.asc) {
        return SortDirection.up;
      }
      if (sortOrderParamNum === ESortOrderMap.desc) {
        return SortDirection.down;
      }

      return SortDirection.none;
    },
    [searchParams]
  );

  return (
    <>
      <CastHeaderColumn
        name="NAME"
        onSortClick={handleSortClick('name')}
        activeSortOrder={{ name: 'NAME', direction: getSortDirection('name') }}
      />
      <CastHeaderColumn
        name="EMAIL"
        onSortClick={handleSortClick('email')}
        activeSortOrder={{ name: 'EMAIL', direction: getSortDirection('email') }}
      />
      <CastHeaderColumn
        name="ROLE"
        onSortClick={handleSortClick('role')}
        activeSortOrder={{ name: 'ROLE', direction: getSortDirection('role') }}
      />
      <CastHeaderColumn
        name="LAST LOGIN"
        onSortClick={handleSortClick('last_login')}
        activeSortOrder={{ name: 'LAST LOGIN', direction: getSortDirection('last_login') }}
      />
      <th>
        <GlobalContainer css="display: inline-block;" />
      </th>
    </>
  );
};

export default CrewContentTableHeader;
